import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\ServiceController::plumbing
* @see app/Http/Controllers/ServiceController.php:14
* @route '/sluzba/vodoinstalace'
*/
export const plumbing = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: plumbing.url(options),
    method: 'get',
})

plumbing.definition = {
    methods: ["get","head"],
    url: '/sluzba/vodoinstalace',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ServiceController::plumbing
* @see app/Http/Controllers/ServiceController.php:14
* @route '/sluzba/vodoinstalace'
*/
plumbing.url = (options?: RouteQueryOptions) => {
    return plumbing.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ServiceController::plumbing
* @see app/Http/Controllers/ServiceController.php:14
* @route '/sluzba/vodoinstalace'
*/
plumbing.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: plumbing.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ServiceController::plumbing
* @see app/Http/Controllers/ServiceController.php:14
* @route '/sluzba/vodoinstalace'
*/
plumbing.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: plumbing.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ServiceController::heating
* @see app/Http/Controllers/ServiceController.php:29
* @route '/sluzba/topenarstvi'
*/
export const heating = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: heating.url(options),
    method: 'get',
})

heating.definition = {
    methods: ["get","head"],
    url: '/sluzba/topenarstvi',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ServiceController::heating
* @see app/Http/Controllers/ServiceController.php:29
* @route '/sluzba/topenarstvi'
*/
heating.url = (options?: RouteQueryOptions) => {
    return heating.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ServiceController::heating
* @see app/Http/Controllers/ServiceController.php:29
* @route '/sluzba/topenarstvi'
*/
heating.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: heating.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ServiceController::heating
* @see app/Http/Controllers/ServiceController.php:29
* @route '/sluzba/topenarstvi'
*/
heating.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: heating.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ServiceController::gas
* @see app/Http/Controllers/ServiceController.php:44
* @route '/sluzba/plynoinstalace'
*/
export const gas = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: gas.url(options),
    method: 'get',
})

gas.definition = {
    methods: ["get","head"],
    url: '/sluzba/plynoinstalace',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ServiceController::gas
* @see app/Http/Controllers/ServiceController.php:44
* @route '/sluzba/plynoinstalace'
*/
gas.url = (options?: RouteQueryOptions) => {
    return gas.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ServiceController::gas
* @see app/Http/Controllers/ServiceController.php:44
* @route '/sluzba/plynoinstalace'
*/
gas.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: gas.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ServiceController::gas
* @see app/Http/Controllers/ServiceController.php:44
* @route '/sluzba/plynoinstalace'
*/
gas.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: gas.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ServiceController::maintenance
* @see app/Http/Controllers/ServiceController.php:59
* @route '/sluzba/servis'
*/
export const maintenance = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: maintenance.url(options),
    method: 'get',
})

maintenance.definition = {
    methods: ["get","head"],
    url: '/sluzba/servis',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ServiceController::maintenance
* @see app/Http/Controllers/ServiceController.php:59
* @route '/sluzba/servis'
*/
maintenance.url = (options?: RouteQueryOptions) => {
    return maintenance.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ServiceController::maintenance
* @see app/Http/Controllers/ServiceController.php:59
* @route '/sluzba/servis'
*/
maintenance.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: maintenance.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ServiceController::maintenance
* @see app/Http/Controllers/ServiceController.php:59
* @route '/sluzba/servis'
*/
maintenance.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: maintenance.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ServiceController::boilerReplacement
* @see app/Http/Controllers/ServiceController.php:74
* @route '/sluzba/vymena-kotlu'
*/
export const boilerReplacement = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: boilerReplacement.url(options),
    method: 'get',
})

boilerReplacement.definition = {
    methods: ["get","head"],
    url: '/sluzba/vymena-kotlu',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ServiceController::boilerReplacement
* @see app/Http/Controllers/ServiceController.php:74
* @route '/sluzba/vymena-kotlu'
*/
boilerReplacement.url = (options?: RouteQueryOptions) => {
    return boilerReplacement.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ServiceController::boilerReplacement
* @see app/Http/Controllers/ServiceController.php:74
* @route '/sluzba/vymena-kotlu'
*/
boilerReplacement.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: boilerReplacement.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ServiceController::boilerReplacement
* @see app/Http/Controllers/ServiceController.php:74
* @route '/sluzba/vymena-kotlu'
*/
boilerReplacement.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: boilerReplacement.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ServiceController::heatPumps
* @see app/Http/Controllers/ServiceController.php:89
* @route '/sluzba/tepelna-cerpadla'
*/
export const heatPumps = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: heatPumps.url(options),
    method: 'get',
})

heatPumps.definition = {
    methods: ["get","head"],
    url: '/sluzba/tepelna-cerpadla',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ServiceController::heatPumps
* @see app/Http/Controllers/ServiceController.php:89
* @route '/sluzba/tepelna-cerpadla'
*/
heatPumps.url = (options?: RouteQueryOptions) => {
    return heatPumps.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ServiceController::heatPumps
* @see app/Http/Controllers/ServiceController.php:89
* @route '/sluzba/tepelna-cerpadla'
*/
heatPumps.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: heatPumps.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ServiceController::heatPumps
* @see app/Http/Controllers/ServiceController.php:89
* @route '/sluzba/tepelna-cerpadla'
*/
heatPumps.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: heatPumps.url(options),
    method: 'head',
})

const ServiceController = { plumbing, heating, gas, maintenance, boilerReplacement, heatPumps }

export default ServiceController